import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

function SitemapModal({ isOpen, onClose }) {
  useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = "hidden"; // 스크롤 막기
      } else {
        document.body.style.overflow = "auto"; // 스크롤 다시 허용
      }
  
      return () => {
        // 모달이 unmount되면 스크롤 다시 허용
        document.body.style.overflow = "auto";
      };
    }, [isOpen]);
  if (!isOpen) return null;
  return(
    <div className="modalWrap sitemap-modal">
      <div className="modal-inner">
        <div className="modal-title">
          <h3 className="title">사이트맵</h3>
          <button className="close-btn" onClick={onClose}>닫기</button>
        </div>
        <div className="modal-textBox scroll">
          <ul className="sitemap-menu">
            <li>
              <span>Company</span>
              <ul className="depth2">
                <li><Link to="/comOverview" className="dropdown-list">회사소개</Link></li>
                <li><Link to="/comHisPubList" className="dropdown-list">회사연혁</Link></li>
                <li><Link to="/coreCompetence" className="dropdown-list">인증 및 협약</Link></li>
              </ul>
            </li>
            <li>
              <span>AI Business</span>
                <ul className="depth2">
                  <li><Link to="/WISplatform" className="dropdown-list">WISplatform</Link></li>
                  <li><Link to="/WISaicc" className="dropdown-list">WISaicc</Link></li>
                  <li><Link to="/WISbot" className="dropdown-list">WISbot</Link></li>
                  <li><Link to="/WISserch" className="dropdown-list">WISsearch</Link></li>
                  <li><Link to="/WISvec" className="dropdown-list">WISvec</Link></li>
                  <li><Link to="/WISrag" className="dropdown-list">WISrag</Link></li>
                  <li><Link to="/WISdoc" className="dropdown-list">WISdoc</Link></li>
                  <li><Link to="/WISscrap" className="dropdown-list">WISscrap</Link></li>
                  <li><Link to="/WISocr" className="dropdown-list">WISocr</Link></li>
                  <li><Link to="/WISvoice" className="dropdown-list">WISvoice</Link></li>
                  <li><Link to="/WISvision" className="dropdown-list">WISvision</Link></li>
                </ul>
            </li>
            <li>
              <span>ESG</span>
              <ul className="depth2">
                <li><Link to="/visionObjective" className="dropdown-list">ESG</Link></li>
                <li><Link to="/enviroMgmt" className="dropdown-list">환경경영</Link></li>
                <li><Link to="/HumanRightMgmt" className="dropdown-list">인권경영</Link></li>
                <li><Link to="/safetyMgmt" className="dropdown-list">안전보건경영</Link></li>
                <li><Link to="/ethicalMgmt" className="dropdown-list">윤리경영</Link></li>
                <li><Link to="/socialContirb" className="dropdown-list">사회공헌</Link></li>
              </ul>
            </li>
            <li>
              <span>SI Business</span>
                <ul className="depth2">
                  <li><Link to="/iTConsulting" className="dropdown-list">IT Consulting</Link></li>
                  <li><Link to="/systemIntegration" className="dropdown-list">System Integration</Link></li>
                  <li><Link to="/solution" className="dropdown-list">Solution</Link></li>
                  <li><Link to="/iTService" className="dropdown-list">IT Service</Link></li>
                  <li><Link to="/constructionCase" className="dropdown-list">구축사례</Link></li>
                </ul>
            </li>
             <li>
              <span>Contact Us</span>
              <ul className="depth2">
                <li><Link to="/locationInfo" className="nav-list">Contact Us</Link></li>
              </ul>
            </li>
            <li>
              <span>Recruit</span>
              <ul className="depth2">
                <li><Link to="/recruitmentGuide" className="nav-list">Recruit</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-b" onClick={onClose}></div>
    </div>
  )
}
export default SitemapModal;